import { useLocation, matchPath } from "react-router-dom";

type ReturnType = boolean;

export function useActiveLink(path: string, deep = true): ReturnType {
  const { pathname } = useLocation();

  const normalActive = path
    ? !!matchPath({ path, end: true }, pathname)
    : false;

  const deepActive = path ? !!matchPath({ path, end: false }, pathname) : false;

  // 分析ページの詳細ビューでもアクティブにするための特別な処理
  const isAnalyticsPath = path === "/dashboard/analytics";
  const isAnalyticsDetailPath =
    pathname.startsWith("/dashboard/analytics/") &&
    pathname !== "/dashboard/analytics";

  if (isAnalyticsPath && isAnalyticsDetailPath) {
    return true;
  }

  // 動画チャットボットの詳細ページでもアクティブにするための特別な処理
  const isVideoChoosePath = path === "/dashboard";
  const isVideoChooseDetailPath =
    pathname.startsWith("/dashboard/video-list/") && pathname !== "/dashboard";

  if (isVideoChoosePath && isVideoChooseDetailPath) {
    return true;
  }

  return deep ? deepActive : normalActive;
}
